export const COLUMNS = [
  {
    Header: 'SKU',
    accessor: 'sku',
  },
  {
    Id: 'Id',
    accessor: '_id',
  },
  {
    Header: 'Image',
    accessor: 'images',
  },
  {
    Header: 'Title',
    accessor: 'name',
  },
  {
    Header: 'Quantity',
    accessor: 'stockQuantity',
  },
  {
    Header: 'Retail Price (AED)',
    accessor: 'walk_in_customer_price',
  },
  {
    Header: 'Wholesaler Price (AED)',
    accessor: 'customer_price',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Edit/Delete',
    accessor: '',
  },
];
